<template>
  <div class="setsLib_wrapper">
    <v-container
      text-xs-center
      style="padding: 0 !important;"
      class="elevation-5"
    >
      <BaseToolbar toolbarTitle="Sets lib">
        <template v-slot:toolbarSearch>
          <v-text-field
            cy-data="cy_Search_sets"
            v-model="search"
            append-icon="search"
            label="Search sets"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-select
            class="hidden-xs-only sport_selection"
            v-model="sport"
            :items="sportTypeList"
            label="Sport"
            :rules="requiredRule"
            item-value="node.valName"
            item-text="node.valName"
          ></v-select>
        </template>
        <template v-slot:toolbarBtn>
          <v-dialog
            v-model="dialog"
            :retain-focus="false"
            max-width="700px"
            persistent
          >
            <template v-slot:activator="{ on }">
              <v-btn color="light-blue darken-2" dark v-on="on">{{
                formTitle
              }}</v-btn>
            </template>
          </v-dialog>
        </template>
      </BaseToolbar>
      <v-tabs
        v-model="tabs"
        background-color="light-blue darken-4"
        dark
        show-arrows
        style="border-top: 1px solid white;"
        fixed-tabs
      >
        <v-tabs-slider color="white"></v-tabs-slider>
        <v-tab
          v-for="item in activityTabs"
          :key="item.node.activityId"
          :value="item.node.USCode"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span color="primary" dark v-on="on">{{ item.node.USCode }}</span>
            </template>
            <span>{{ item.node.activityCategory }}</span>
          </v-tooltip>
        </v-tab>
        <v-tabs-items v-model="tabs">
          <v-tab-item
            v-for="subItem in activityTabs"
            :key="subItem.node.activityId"
          >
            <!-- REMOVE FILTER LOGIC FROM HERE -->
            <v-data-table
              :headers="headers"
              :items="tableList"
              :search="search"
              :loading="loadingTable"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              hide-default-footer
              @page-count="pageCount = $event"
            >
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  max-width="700px"
                  persistent
                  :retain-focus="false"
                >
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm6>
                            <v-text-field
                              v-model="editedItem.name"
                              label="Sets name"
                              :rules="nameRules"
                              :counter="50"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field
                              v-model="editedItem.purpose"
                              label="Sets purpose"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-select
                              v-model="editedItem.status"
                              :items="['Public', 'Private']"
                              label="Status"
                              :rules="requiredRule"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-select
                              v-model="editedItem.equipment"
                              label="Equipment"
                              :items="equipmentList"
                              item-value="node.valName"
                              item-text="node.valName"
                              multiple
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-select
                              v-model="editedItem.facilityType"
                              :items="facilityList"
                              label="Facility"
                              :rules="requiredRule"
                              item-value="node.valName"
                              item-text="node.valName"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-select
                              v-model="editedItem.sportType"
                              :items="sportTypeList"
                              label="Sport"
                              :rules="requiredRule"
                              item-value="node.valName"
                              item-text="node.valName"
                              chips
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-select
                              label="Tag"
                              :items="tagsSetsList"
                              :rules="requiredRule"
                              v-model="editedItem.tag"
                              :menu-props="{ maxHeight: 'auto' }"
                              multiple
                              chips
                            >
                              <!-- <template slot-scope="data">
                                {{ data.node.valName }}
                              </template> -->
                            </v-select>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea
                              v-model="editedItem.desc"
                              label="Sets desc"
                            ></v-textarea>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field
                              v-model="editedItem.userId"
                              type="number"
                              label="User id"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field
                              v-model="editedItem.teamId"
                              type="number"
                              label="Team id"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="secondary" text @click="close"
                        >Cancel</v-btn
                      >
                      <v-btn
                        :disabled="!isFormValid"
                        color="secondary"
                        text
                        @click="funcName"
                        >{{ editedIndex > 0 ? "Edit" : "Add" }}</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>

              <template v-slot:[`item.node.set`]="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.node.set"
                  :retain-focus="false"
                  width="600px"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                >
                  {{ item.node.set }}
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.node.noOfSets"
                      label="Number of Sets"
                      counter
                    ></v-text-field>
                    <v-text-field
                      v-model="item.node.noOfRep"
                      label="Number of Reps"
                      counter
                    ></v-text-field>
                    <v-text-field
                      v-model="item.node.distance"
                      label="Distance"
                      counter
                    ></v-text-field>
                    <v-text-field
                      v-model="item.node.stroke"
                      label="Stroke"
                      counter
                    ></v-text-field>
                    <v-text-field
                      v-model="item.node.setInterval"
                      label="Interval"
                      counter
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>
              <template v-slot:[`item.node.setDesc`]="{ item }">
                <v-edit-dialog
                  :retain-focus="false"
                  :return-value.sync="item.node.setDesc"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                >
                  {{ item.node.setDesc }}
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.node.setDesc"
                      :rules="[nameRules]"
                      label="Short Desc"
                      counter
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>
              <template v-slot:[`item.node.activityId`]="{ item }">
                <td v-if="!!item.node.activityId" class="text-xs-right">
                  {{
                    activityList.edges.find(
                      item => item.node.activityId == item.node.activityId
                    ).node.USCode
                  }}
                </td>
                <td v-else class="text-xs-right">
                  {{ item.node.activityId }}
                </td>
              </template>

              <template v-slot:[`item.node.tag`]="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.node.tag"
                  :retain-focus="false"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                >
                  {{ item.node.tag }}
                  <template v-slot:input>
                    <v-select
                      label="Tag"
                      :items="tagsSetsList"
                      v-model="editedItem.tag"
                      :menu-props="{ maxHeight: 'auto' }"
                      multiple
                      chips
                    >
                      <template slot-scope="data">
                        {{ data.node.valName }}
                      </template>
                    </v-select>
                  </template>
                </v-edit-dialog>
              </template>

              <!--template slot="items">
                <td></td>
                <td class="text-xs-right">{{ item.node.equipment }}</td>
                

                <td>
                  <v-edit-dialog :return-value.sync="item.node.sportType">
                    {{ item.node.sportType }}
                    <template v-slot:input>
                      <v-select
                        class="hidden-xs-only"
                        v-model="item.node.sportType"
                        :items="sportTypeList()"
                        label="Sport"
                        :rules="requiredRule"
                        item-value="node.valName"
                        item-text="node.valName"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>

                <td class="justify-center layout px-0">
                  <v-icon small class="mr-2" @click="editItem(item.node)">
                    edit
                  </v-icon>
                  <v-icon small @click="deleteItem(item.node)">
                    delete
                  </v-icon>
                </td>
              </template-->
              <template v-slot:[`item.action`]="{ item }">
                <v-icon small class="mr-2" @click="editItem(item.node)">
                  edit
                </v-icon>
                <v-icon small @click="deleteSet(item.node)">
                  delete
                </v-icon>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-container>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        color="light-blue darken-4"
        :length="pageCount"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { randomInteger } from "../../_helpers/index";
import { validationRules } from "../../constants/global";
import { libsHeaders, libsDefaultItem } from "../../constants/libs";
import BaseToolbar from "../base/BaseToolbar.vue";

export default {
  components: { BaseToolbar },
  data() {
    return {
      sport: "SWIMMING",
      editedSetItem: null,
      direction: "bottom",
      isFormValid: true,
      true: true,
      false: false,
      on: "",
      tabs: 0,
      status: "Public",
      search: "",
      dialog: false,
      menu: false,
      loadingTable: false,
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      name: "Default",
      // pagination: {'sortBy': 'node.setsId', 'descending': false, 'rowsPerPage': -1},
      nameRules: validationRules.name,
      requiredRule: validationRules.required,
      headers: libsHeaders,
      editedIndex: -1,
      editedItem: {
        name: "",
        desc: "",
        purpose: "",
        status: "",
        tag: "",
        equipment: "",
        sportType: "",
        facilityType: "",
        userId: null,
        teamId: null
      },
      defaultItem: libsDefaultItem
    };
  },
  async created() {
    Promise.all([
      this.$store.dispatch("allSetsLib"),
      this.$store.dispatch("allActivity")
    ])
      .then(() => {
        this.loadingTable = false;
      })
      .catch(error => {
        console.error(error);
        this.loadingTable = false;
      });
  },
  computed: {
    ...mapGetters([
      "loading",
      "setsLib",
      "categoryValue",
      "activityList",
      "user"
    ]),
    tabName() {
      if (this.activityList.edges) {
        return this.activityTabs.filter((_, indx) => indx === this.tabs)[0].node
          .USCode;
      } else {
        return "";
      }
    },
    funcName() {
      return this.editedIndex === -1 ? this.addNewSet : this.editSet;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Set" : "Edit Set";
    },
    equipmentList() {
      if (this.categoryValue.edges) {
        return this.categoryValue.edges.filter(
          category => category.node.category.catName == "EQUIPMENT"
        );
      } else {
        return [];
      }
    },
    sportTypeList() {
      if (this.categoryValue.edges) {
        return this.categoryValue.edges.filter(
          category => category.node.category.catName == "SPORT_TYPE"
        );
      } else {
        return [];
      }
    },
    tableList() {
      if (this.setsLib.edges) {
        return this.setsLib.edges
          .filter(
            item =>
              item.node.sportType === this.sport &&
              String(item.node.tag)
                .split(",")
                .includes(this.tabName)
          )
          .map(el => {
            return {
              node: {
                ...el.node,
                set: `${el.node.noOfSets}x${el.node.noOfRep}x${el.node.distance} ${el.node.stroke} @ ${el.node.setInterval}`
              }
            };
          });
      } else {
        return [];
      }
    },
    facilityList() {
      if (this.categoryValue.edges) {
        return this.categoryValue.edges.filter(
          category => category.node.category.catName == "FACILITY"
        );
      } else {
        return [];
      }
    },
    activityTabs() {
      if (this.activityList.edges) {
        return this.activityList.edges.filter(i => i.node.USCode !== "");
      } else {
        return [];
      }
    },
    tagsSetsList() {
      if (this.activityList.edges) {
        return this.activityList.edges
          .filter(tag => tag.node.USCode !== "")
          .map(tag => tag.node.USCode);
      } else {
        return [];
      }
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    ...mapActions(["setLibMerge", "setsLibDelete", "setLibEdit"]),
    handleGetSetsList() {
      //reach out of Vuex store, fire action that gets sets
      this.$store.dispatch("allSetsLib");
    },
    editItem(item) {
      console.log(item);
      this.dialog = true;
      this.editedIndex = 1;
      this.editedSetItem = item;
      this.editedItem.name = item.setName;
      this.editedItem.desc = item.setDesc;
      this.editedItem.equipment = item.equipment.split(",");
      this.editedItem.sportType = item.sportType;
      this.editedItem.facilityType = item.facilityType;
      this.editedItem.userId = item.userId;
      this.editedItem.tag = item.tag.split(",");
    },
    editSet() {
      this.loadingTable = true;
      this.setLibEdit({
        setId: +this.editedSetItem.setId,
        setName: String(this.editedItem.name),
        setDesc: String(this.editedItem.desc),
        setPurpose: String(this.editedItem.purpose),
        noOfSets: +this.editedSetItem.noOfSets,
        noOfRep: +this.editedSetItem.noOfRep,
        distance: +this.editedSetItem.distance,
        distanceSum: +this.editedSetItem.distanceSum,
        stroke: this.editedSetItem.stroke,
        tag: this.editedItem.tag.toString().replace(/[\[\]']+/g, ""), // eslint-disable-line
        setInterval: this.editedSetItem.setInterval,
        timePerDist: +this.editedSetItem.timePerDist,
        timeTotal: +this.editedSetItem.timeTotal,
        equipment: String(this.editedItem.equipment),
        sportType: String(this.editedItem.sportType),
        updateSource: "TEST",
        userId: this.editedItem.userId || this.editedSetItem.userId,
        teamId: this.editedItem.teamId || 1,
        facilityType: this.editedItem.facilityType
      }).then(() => {
        this.loadingTable = false;
        this.$toast.success(`Set ${this.editedItem.name} has been edited`);
        this.dialog = false;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedSetItem = null;
        this.editedIndex = -1;
      });
    },

    deleteSet(item) {
      this.loadingTable = true;
      const setLibName = item.setName;
      this.setsLibDelete({
        setId: parseInt(item.setId, 10)
      }).then(() => {
        this.loadingTable = false;
        this.$toast.error(`SetLib ${setLibName} was deleted`);
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    open() {},
    cancel() {},
    addNewSet() {
      this.loadingTable = true;
      this.setLibMerge({
        setId: randomInteger(1, 1200),
        setName: String(this.editedItem.name),
        setDesc: String(this.editedItem.desc),
        setPurpose: String(this.editedItem.purpose),
        noOfSets: 0,
        noOfRep: 0,
        distance: 0,
        distanceSum: 0,
        stroke: "",
        tag: this.editedItem.tag.toString().replace(/[\[\]']+/g, ""), // eslint-disable-line
        setInterval: 0,
        timePerDist: 0,
        timeTotal: 0,
        equipment: String(this.editedItem.equipment),
        sportType: String(this.editedItem.sportType),
        updateSource: "TEST",
        userId: this.editedItem.userId || 1,
        teamId: this.editedItem.teamId || 1,
        facilityType: this.editedItem.facilityType
      }).then(() => {
        this.loadingTable = false;
        this.$toast.success(`Set ${this.editedItem.name} has been added`);
        this.dialog = false;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    }
  }
};
</script>

<style lang="scss">
.sport_selection {
  .v-text-field__details {
    display: none !important;
  }
  .v-input__slot {
    margin: 0 !important;
  }
}
</style>
